import { createContext } from "react";
import { Language } from "api/type";

// Define the context with a specific type
const LanguageContext = createContext<Language>(["en", () => {}]);

export default LanguageContext;
